import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, SpinLoading, Toast } from 'antd-mobile';
import { CheckCircleOutline, CloseCircleOutline } from 'antd-mobile-icons';
import { claimNationalDay2026Prop } from '../services/api';
import { useAuth } from '../context/AuthContext';
import './Spring2026QRCodePage.css';

/** 门店物料二维码地址：https://m.taogo.shop/national-day-2026 */
export default function NationalDay2026Page() {
  const navigate = useNavigate();
  const { user, initialized, isAuthenticated } = useAuth();
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const redirectDone = useRef(false);
  const claimStarted = useRef(false);

  useEffect(() => {
    if (!initialized || isAuthenticated || redirectDone.current) return;
    redirectDone.current = true;
    Toast.show({ content: 'Please sign in or register first.' });
    navigate(`/login?redirect=${encodeURIComponent('/national-day-2026')}`, { replace: true });
  }, [initialized, isAuthenticated, navigate]);

  useEffect(() => {
    if (!initialized || !isAuthenticated || !user?.id || claimStarted.current) return;
    claimStarted.current = true;
    (async () => {
      setBusy(true);
      try {
        const data = await claimNationalDay2026Prop(user.id);
        const newlyClaimed = data?.newlyClaimed === true;
        const message = data?.message || (newlyClaimed
          ? 'Malaysia National Day token claimed successfully.'
          : 'You have already claimed this token.');
        setResult({ ok: newlyClaimed, message });
        Toast.show({ icon: newlyClaimed ? 'success' : 'fail', content: message });
      } catch (error) {
        const message = error?.message || 'Unable to claim the token.';
        setResult({ ok: false, message });
        Toast.show({ icon: 'fail', content: message });
      } finally {
        setBusy(false);
      }
    })();
  }, [initialized, isAuthenticated, user?.id]);

  if (!initialized || !isAuthenticated || busy || !result) {
    return (
      <div className="spring2026-qrcode-page">
        <div className="spring2026-qrcode-container">
          <SpinLoading color="primary" style={{ fontSize: '48px' }} />
          <div className="spring2026-qrcode-loading-text">
            {!initialized || !isAuthenticated ? 'Redirecting to sign in…' : 'Claiming your token…'}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="spring2026-qrcode-page">
      <div className="spring2026-qrcode-container">
        <Card className="spring2026-qrcode-result-card">
          <div style={{ fontSize: 64, marginBottom: 8 }}>🇲🇾</div>
          {result.ok ? (
            <CheckCircleOutline style={{ fontSize: 48, color: '#52c41a', marginBottom: 12 }} />
          ) : (
            <CloseCircleOutline style={{ fontSize: 48, color: '#ff4d4f', marginBottom: 12 }} />
          )}
          <div className="spring2026-qrcode-result-title">
            {result.ok ? 'Token received' : 'Cannot claim again'}
          </div>
          <div className="spring2026-qrcode-result-message">{result.message}</div>
          <div className="spring2026-qrcode-result-message" style={{ marginTop: 8 }}>
            Malaysia National Day activity: 26–31 August 2026. Token expires after 31 August.
          </div>
          <Button block color="primary" onClick={() => navigate('/', { replace: true })} style={{ marginTop: 24 }}>
            View My Token
          </Button>
        </Card>
      </div>
    </div>
  );
}
